<template>
  <div>
    <div class="t_out_box">
      <!-- 筛选 -->
      <div class="headerSearch">
        <el-form
          v-model="from"
          class="t_search_form"
          label-position="left"
          style="width: 90%; margin-left: auto; margin-right: auto"
          label-width="90px"
        >
          <el-form-item label="化学品：" label-width="100px">
            <el-input
              v-model="from.param.hxpMc"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="仓库名称：" label-width="85px">
            <el-select v-model="from.param.ckId" filterable placeholder="请选择">
              <el-option
                v-for="item in listckxx"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库日期：" label-width="85px">
            <el-date-picker
              v-model="Sxrkrq"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="hsaixuanriqichange"
            />
          </el-form-item>
          <el-form-item label="状态：" label-width="60px">
            <el-select v-model="from.param.zt" placeholder="请选择">
              <el-option
                v-for="item in zhuangtaixiala"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="hchongzhi"
          >重置</el-button>
        </el-form>
      </div>

      <!-- 列表 -->
      <div class="t_con_w" style="padding-top: 40px; padding-bottom: 57px">
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <div
            style="
              background-color: #f4f4f4;
              padding: 12px 10px;
              border: 1px solid #f4f4f4;
            "
          >
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              type="primary"
              size="mini"
              style="background-color: #4170ff; border: none; color: white"
              @click="add(0)"
            >新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="hdaochu"
            >导出</el-button>
          </div>
          <el-table
            ref="cktable"
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
          >
            <el-table-column
              align="center"
              prop="rkbh"
              :show-overflow-tooltip="true"
              label="入库编号"
            />
            <el-table-column
              align="center"
              prop="ckmc"
              :show-overflow-tooltip="true"
              label="仓库名称"
            />
            <el-table-column
              align="center"
              prop="hxpMc"
              :show-overflow-tooltip="true"
              label="化学品名称"
            />

            <el-table-column
              align="center"
              prop="rksl"
              :show-overflow-tooltip="true"
              label="增溢数量"
            />
            <el-table-column
              align="center"
              prop="zyyy"
              :show-overflow-tooltip="true"
              label="增溢原因"
            />

            <el-table-column
              align="center"
              prop="rkrq"
              :show-overflow-tooltip="true"
              label="入库日期"
            />

            <el-table-column align="center" prop="bgcs" label="变更次数">
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="zt"
              label="状态"
            >
              <template slot-scope="scope">
                <span :style="scope.row.zt == '01' ||scope.row.zt == '24'?'color: #6fc89a':scope.row.zt == '23'?'color: #ff0000': scope.row.zt == '11' ||scope.row.zt == '21' ?'color: #43a5e2':'color: #333333'">
                  {{ scope.row.ztLabel }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="cz"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.zt != '00'
                  "
                  v-preventReClick
                  size="mini"
                  icon="el-icon-document"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(1, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == '01'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #feb800; border: none; color: white"
                  @click="add(2, scope.row)"
                >变更</el-button>
                <!-- <el-button
                  v-if="scope.row.zt == '11'"
                  disabled
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #c8c9cc; border: none; color: white"
                     v-preventReClick   @click="add(2, scope.row)"
                  >变更</el-button
                > -->
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(3, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-delete"
                  style="background-color: #ff5721; border: none; color: white"
                  @click="hdelete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="from.size"
            class="el-page"
            :current-page="currentpage"
            @size-change="pagesizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <!-- 页面弹框 -->
    <el-dialog
      v-if="digshow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="digshow"
      width="1200px"
    >
      <div class="t_dig" v-loading="loading">
        <div style="font-weight: bold; font-size: 20px; text-align: center">
          {{ tetle }}
        </div>
        <div style="background-color: white">
          <div class="t_rk">
            <el-form
              ref="formTK"
              label-position="right"
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              "
              label-width="100px"
              :model="tkdata"
              :rules="rules"
            >
              <el-form-item
                label="化学品："
                style="margin-right: 0; width: 45%"
                prop="hxpBm"
              >
                <el-cascader
                  v-if="!(ckshow || bgshow)"
                  v-model="tkdata.hxpBm"
                  :disabled="ckshow || bgshow || tetle == '查看增溢入库'"
                  :options="jilianlb"
                  clearable
                  @change="handleChange"
                />
                <el-input
                  v-else
                  v-model="tkdata.hxpMc"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="存放仓库："
                style="margin-right: 0; width: 45%"
                prop="ckId"
              >
                <el-select
                  v-if="!ckshow"
                  v-model="tkdata.ckId"
                  :disabled="ckshow"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="cfckChange"
                >
                  <el-option
                    v-for="item in cangkuxiala"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="tkdata.ckmc"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="增溢数量："
                style="margin-right: 0; width: 45%"
                prop="rksl"
              >
                <el-input
                  v-model="tkdata.rksl"
                  :disabled="ckshow"
                  style="width: 60%"
                />
                <el-select
                  v-model="tkdata.rkslDw"
                  :disabled="ckshow"
                  placeholder="单位"
                  style="width: 35%; margin-left: 5%"
                >
                  <el-option
                    v-for="(item, index) in ckslList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item
                label="保管员姓名："
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="tkdata.bgyxm"
                  :disabled="true"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="入库日期："
                style="margin-right: 0; width: 45%"
                prop="rkrq"
              >
                <el-date-picker
                  v-model="tkdata.rkrq"
                  :disabled="tetle == '查看增溢入库'"
                  style="width: 100%"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerBeginDateBefore"
                />
              </el-form-item>
              <el-form-item
                label="经办人："
                style="margin-right: 0; width: 45%"
                prop="jbrName"
              >
                <el-input
                  v-if="ckshow || bgshow"
                  v-model="tkdata.jbrName"
                  disabled
                  style="width: 100%"
                />
                <el-select
                  v-else
                  v-model="tkdata.jbrName"
                  filterable
                  placeholder="选择经办人"
                  style="width: 100%"
                  @change="hjbrChange"
                >
                  <el-option
                    v-for="item in jingbanrenlist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="增溢原因："
                style="margin-right: 0; width: 100%"
                prop="zyyy"
                :rules="{
                  required: true,
                  validator: (rule, value, callback) => {
                    lengthValidate(rule, value, callback, 'bt', 500);
                  },
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input
                  v-model="tkdata.zyyy"
                  style="width: 100%"
                  type="textarea"
                  :row="3"
                  :disabled="ckshow || bgshow"
                  resize="none"
                />
              </el-form-item>

              <el-form-item
                label="登记人："
                style="margin-right: 0; width: 45%"
              >
                <el-input v-model="djr" disabled style="width: 100%" />
              </el-form-item>
              <el-form-item
                v-if="djsjshow || bgshow"
                label="登记时间："
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="tkdata.djsj"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item v-else label="登记时间:" style="margin-right: 0; width: 45%">
                <el-date-picker
                  :value="new Date()"
                  type="date"
                  style="width: 100%;"
                  placeholder="选择日期"
                  disabled
                  format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
              <el-form-item
                label="备注："
                style="margin-right: 0; width: 100%"
                prop="bz"
                :rules="{
                  validator: (rule, value, callback) => {
                    lengthValidate(rule, value, callback, 'xt', 255);
                  },
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input
                  v-model="tkdata.bz"
                  :disabled="ckshow || bgshow"
                  style="width: 100%"
                />
              </el-form-item>

              <el-form-item
                v-if="biangengShow"
                label="变更理由："
                style="margin-right: 0; width: 100%"
                prop="bgly"
                :rules="{
                  required: true,
                  validator: (rule, value, callback) => {
                    lengthValidate(rule, tkdata.bgly, callback, 'bt', 1000);
                  },
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input v-model="tkdata.bgly" style="width: 100%" />
              </el-form-item>
              <el-form-item
                label="证明材料："
                style="margin-right: 0; width: 100%"
                prop="images"
                :rules="{
                  required: true,
                  validator: fileValidator
                }"
              >
                <el-upload

                  :disabled="tetle == '查看增溢入库' || tetle == '变更增溢入库'"
                  :headers="token"
                  :action="returnSaveFile"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :limit="6"
                  :file-list="fileList"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeUpload"
                >
                  <i class="el-icon-plus" />
                </el-upload>
                <el-dialog
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                  :visible.sync="dialogVisible"
                  append-to-body
                >
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
              </el-form-item>
            </el-form>
            <splcCom
              v-if="tetle == '查看增溢入库' || tetle == '变更增溢入库'"
              ref="splcRef"
            />
            <div
              v-if="tetle == '查看增溢入库' || tetle == '变更增溢入库'"
              class=""
            >
              <div
                v-if="curRowObj.bgcs >= 1"
                class="title"
                style="margin: 40px 0 50px 0"
              >
                <img src="../assets/img/bgsp/rkbg.png" alt="" srcset="">
              </div>
              <bgcsOfDetail
                v-if="curRowObj.bgcs >= 1"
                :cur-row-obj="curRowObj"
                :cur-type="curType"
                :bgcs-t-k-name="'disShow'"
                @bacsCkXqShow="bacsCkXqShow"
              />
            </div>
            <!-- 新增 -->
            <div
              v-if="!djsjshow && !ckshow && !bgshow"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  margin-right: 190px;
                  background-color: #ebebeb;
                  width: 148px;
                  height: 60px;
                  color: #333333;
                  border: none;
                "
                @click="zc"
              >暂时保存</el-button>
              <el-button
                v-preventReClick
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                type="primary"
                @click="hrk"
              >入库</el-button>
            </div>
            <!-- 查看 -->
            <div
              v-if="djsjshow && ckshow && !bgshow"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                text-align: center;
                display: flex;
                justify-content: space-around;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                @click="digshow = false"
              >确定</el-button>
            </div>
            <!-- 变更 -->
            <div
              v-if="djsjshow && !ckshow && bgshow"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                text-align: center;
                display: flex;
                justify-content: space-around;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                @click="htjbg"
              >提交变更</el-button>
            </div>
            <!-- 编辑 -->
            <div
              v-if="djsjshow && !ckshow && !bgshow"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  margin-right: 190px;
                  background-color: #ebebeb;
                  width: 148px;
                  height: 60px;
                  color: #333333;
                  border: none;
                "
                @click="zc"
              >暂时保存</el-button>
              <el-button
                v-preventReClick
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                type="primary"
                @click="hrk"
              >入库</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <div class="t_dig">
        <bgxqCom
          v-if="dialogFormVisible"
          bgcs-t-k-name="增溢入库"
          :dgcs-xq-id="dgcsXqId"
        />
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button
            v-preventReClick
            type="primary"
            style="background-color: #4170ff; border: none"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { lengthValidate } from '@/assets/js/validate'
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'
import splcCom from '../components/bgxq/splccom.vue'
// 获取接口地址
import bgcs from '@/components/bgcs'
import {
  url1,
  getToken,
  getListCkcx,
  returnSaveFile,
  returnShowPic,
  userInfofLogin
} from '@/assets/js/common.js'
import {
    APIzhuangtai, // 状态下拉
    APIcangku, // 仓库下拉
    APIzylist, // 首页列表
    APIhuaxuepinJL, // 化学品级联
    APIjingbanren, // 经办人
    APIzyrkTijiaoxinxi, // 新增 编辑 保存
    APIzyxiangqing, // 详情
    APIzydelete, // 删除
    APIbgjy, // 变更校验
    APIxxbg, // 变更提交
    APIdaochu, APIzyrkTijiaoxinxiTemp // 导出
} from '@/assets/js/wangshuai.js'
import { gethqdw } from '@/assets/js/ccgl.js'
import {getCkxxByCskc} from "@/assets/js/ccgl";
import {getLyrList} from "@/assets/js/thrk";
export default {
  name: 'Zyrk',
  components: { bgcs, bgcsOfDetail, bgxqCom, splcCom },
  data() {
    return {
      loading: false,
      cur_click_type: '',
      bgcsTKName: '增溢入库',
      bgwindow: false,
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '', // 返回保存图片路径
      returnShowPic: '', // 返回回显图片路径

      dialogImageUrl: '',
      dialogVisible: false,
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tetle: '新增增溢入库',
      // 登记时间展示
      djsjshow: false,
      // 查看
      ckshow: false,
      // 表更
      bgshow: false,
      digshow: false,

      tableData: [],
      fileList: [],
      zhuangtaixiala: [], // 状态下拉
      cangkuxiala: [], // 仓库名称下拉
      listckxx: [], // 列表查询仓库名称下拉

      jingbanrenlist: [], // 经办人下拉
      // 弹框
      tkdata: {
        id: '',
        dwId: '',
        rkbh: '',
        ckId: '',
        ckmc: '',
        hxpBm: '',
        rksl: '',
        rkslDw: '',
        rkrq: '',
        zyyy: '',
        bz: '',
        zt: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        jbrId: '',
        jbrName: '',
        djrLabel: '',
        djsj: '',
        addFjDto: [],
        delFjDto: [],
        bgly: ''
      },
      jilianlb: [],
      ckslList: [], // 单位下拉
      biangengShow: false, // 变更原因显示
      hxpval: '',

      // 弹框校验
      rules: {
        hxpBm: [
          {
            required: true,
            message: '选择化学品',
            trigger: ['blur', 'change']
          }
        ],

        jbrName: [
          {
            required: true,
            message: '请选择经办人',
            trigger: ['blur', 'change']
          }
        ],

        jbName: [
          { required: true, message: '请输入委托方经办人', trigger: 'blur' }
        ],

        jbPhone: [
          { required: true, message: '请输入委托方电话', trigger: 'blur' }
        ],

        // bgly: [{ required: true, message: "请输入变更理由", trigger: "blur" }],
        // zyyy: [{ required: true, message: "请输入增益原因", trigger: "blur" }],

        ckId: [
          {
            required: true,
            message: '请选择存放仓库',
            trigger: ['blur', 'change']
          }
        ],
        rksl: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!(value + '')) {
                return callback(new Error('请输入入库数量'))
              }
              const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
              if (!this.bgshow && !reg.test(value)) {
                return callback(new Error('请输入大于或等于0的数量值'))
              } else if (
                /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) ==
                false
              ) {
                return callback(new Error('整数位最大长度9位,保留3位小数'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        rkrq: [{ required: true, message: '请选择入库日期', trigger: 'blur' }],
        djsj: [{ required: true, message: '请选择登记日期', trigger: 'blur' }]
      },

      delFjxxs: [],
      djr: '', // 登记人

      total: 0,
      from: {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          ckId: '',
          beginRkrq: '',
          endRkrq: '',
          zt: ''
        }
      },
      Sxrkrq: [],
      currentpage: 0,

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },

  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
      }
    })
  },

  mounted() {
    // 获取筛选下拉
    this.hSelfcall()

    // 获取列表
    this.hzylist()

    // 获取弹框中化学品级联
    this.hhxpjilian()
  },
  methods: {
    fileValidator(rule, value, callback) {
      if (this.tetle != '变更增溢入库' && (!this.fileList || this.fileList.length === 0)) {
        callback(new Error('证明材料必传!'))
      } else {
        callback()
      }
    },
    lengthValidate,
    // 变更次数弹框
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.dialogFormVisibl = false
    },
    // 点击变更次数
    bgcsClick(curRow) {
      this.$bus.emit('bgcsOpen', curRow, '7')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 导出
    hdaochu() {
      APIdaochu(this.from).then((res) => {
        const table = '增溢入库'
        const a = document.createElement('a')
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 重置筛选
    hchongzhi() {
      this.from.page = 1
      this.from.size = 10
      this.from.param.hxpMc = ''
      this.from.param.ckId = ''
      this.from.param.beginRkrq = ''
      this.from.param.endRkrq = ''
      this.from.param.zt = ''
      this.Sxrkrq = []

      this.hzylist()
    },
    // 时间筛选
    hsaixuanriqichange(data) {
      if (data == null) {
        this.from.param.beginRkrq = ''
        this.from.param.endRkrq = ''
      } else {
        this.from.param.beginRkrq = data[0]
        this.from.param.endRkrq = data[1]
      }
    },
    // 内部分页方法
    pagesizeChange(val) {
      this.from.size = val
      this.hzylist()
    },
    handleCurrentChange(val) {
      this.from.page = val
      this.hzylist()
    },
    // 弹框方法
    // 成功上传图片
    handleAvatarSuccess(res, file) {
      this.fileList.push(file)
      if (!this.tkdata.addFjDto) {
        this.tkdata.addFjDto = []
      }
      this.tkdata.addFjDto.push({
        wjdz: res.data.url
      })
    },
    // 化学品级联触发
    handleChange(val) {
      if (val) {
        this.tkdata.rkslDw = ''
        this.tkdata.hxpBm = val[val.length - 1]
        gethqdw(val[val.length - 1]).then((res) => {
          this.ckslList = res.data.data
        })
      }
    },
    // 存放仓库下拉
    cfckChange(val) {
      this.cangkuxiala.filter((item, index) => {
        if (item.value == val) {
          this.tkdata.ckId = item.value
          this.tkdata.ckmc = item.label
          this.tkdata.bgyId = item.ckbgyId
          this.tkdata.bgyxm = item.ckbgy
          this.tkdata.bgydh = item.ckbgyDh
        }
      })
    },

    // 选择经办人
    hjbrChange(data) {
      this.jingbanrenlist.forEach((item) => {
        if (data == item.value) {
          this.tkdata.jbrId = item.value
          this.tkdata.jbrName = item.label
        }
      })
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      // file包含id时，将删除主键存取
      if (file.id) {
        this.delFjxxs.push({
          id: file.id
        })
      } else {
        // 删除的为未提交过得文件
        if (!this.tkdata.addFjDto) {
          return
        }
        var indeximage = this.tkdata.addFjDto.forEach((item, index) => {
          if (item.wjdz == file.response.data.url) return index
        })
        this.tkdata.addFjDto.splice(indeximage, 1)
      }
    },

    // 弹框按钮
    add(type, data) {
      this.curRowObj = {}
      this.digshow = !this.digshow
      this.biangengShow = false
      this.cur_click_type = type
      // this.from.page = 1;
      // this.from.size = 10;
      // this.from.param.hxpMc = "";
      // this.from.param.ckId = "";
      // this.from.param.beginRkrq = "";
      // this.from.param.endRkrq = "";
      // this.from.param.zt = "";
      // this.Sxrkrq = [];
      // this.hchongzhi();
      this.hqingkongsuoyou()
      if (type == 0) {
        // 新增
        this.djsjshow = false
        this.ckshow = false
        this.bgshow = false
        this.tetle = '新增增溢入库'
        this.getCkxxAndJbr()
        setTimeout(() => {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'inline-block'
        }, 30)
      } else if (type == 1) {
        // 查看
        this.djsjshow = true
        this.ckshow = true
        this.bgshow = false
        this.tetle = '查看增溢入库'
        this.hdantiaoxiangqing(data.id)

        setTimeout(() => {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'none'
        }, 30)

        this.initCon(data, 7)
      } else if (type == 2) {
        // 变更
        this.djsjshow = true
        this.ckshow = false
        this.bgshow = true
        this.tetle = '变更增溢入库'
        this.biangengShow = true

        this.hdantiaoxiangqing(data.id)
        this.initCon(data, 7)
      } else if (type == 3) {
        // 编辑
        this.djsjshow = true
        this.ckshow = false
        this.bgshow = false
        this.tetle = '编辑增溢入库'
        this.hdantiaoxiangqing(data.id)
        setTimeout(() => {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'inline-block'
        }, 30)
      }
    },
    // 暂存
    zc() {
        this.loading = true
        this.from.page = 1
        this.tkdata.zt = '00'
        const params = Object.assign({}, this.tkdata)
        params.delFjDto = this.delFjxxs
        APIzyrkTijiaoxinxiTemp(params).then((res) => {
            this.loading = false
            this.digshow = !this.digshow
            this.hzylist()
            this.hqingkongsuoyou()
        }).catch((error) => {
            this.loading = false
        })
    },
    // 入库
    hrk() {
      this.$refs.formTK.validate((valid) => {
        if (valid) {
          this.loading = true
          this.from.page = 1
          this.tkdata.zt = '01'
          this.currentpage = 1
          APIzyrkTijiaoxinxi(this.tkdata).then((res) => {
            this.loading = false
            this.digshow = !this.digshow
            this.hzylist()

            this.hqingkongsuoyou()
          }).catch((error) => {
            this.loading = false
          })
        }
      })
    },
    // 删除
    hdelete(data) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          APIzydelete(data.id).then((res) => {
            if (res.data.code == '000000') {
              this.hzylist()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 提交变更
    htjbg() {
      this.$refs.formTK.validate((valid) => {
        if (valid) {
          const obj = {
            id: this.tkdata.id,
            hxpBm: this.tkdata.hxpBm,
            ckId: this.tkdata.ckId,
            rksl: this.tkdata.rksl,
            rkslDw: this.tkdata.rkslDw
          }
          APIbgjy(obj).then((res) => {
            let tsxx = ''
            if (res.data.data.type == 'success') {
              tsxx = '是否确认提交变更?'
            } else {
              tsxx =
                "<span style='color:red'>" +
                res.data.data.msg +
                '</span>,是否确认提交变更?'
            }
            this.$confirm(tsxx, {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning',
              center: true
            }).then(() => {
              this.loading = true
              const duixiang = {
                id: this.tkdata.id,
                dwId: this.tkdata.dwId,
                rkbh: this.tkdata.rkbh,
                hxpBm: this.tkdata.hxpBm,
                ckId: this.tkdata.ckId,
                rksl: this.tkdata.rksl,
                rkslDw: this.tkdata.rkslDw,
                rkrq: this.tkdata.rkrq,
                bgly: this.tkdata.bgly
              }
              APIxxbg(duixiang).then((res) => {
                this.loading = false
                this.hzylist()
                this.hqingkongsuoyou()
                this.digshow = !this.digshow
                if (res.status == 200) {
                  this.$message.success('变更成功')
                  this.reset()
                } else {
                  return
                }
              }).catch((error) => {
                this.loading = false
              })
              // this.$message({
              //   type: "success",
              //   message: "提交成功!",
              // });
            })
          })
        }
      })
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    // 获取 筛选下拉
    hSelfcall() {
      // 搜索下拉状态
      APIzhuangtai().then((res) => {
        this.zhuangtaixiala = res.data.data
      })

      // 列表搜索下拉仓库
      getListCkcx().then((res) => {
        this.listckxx = res.data.data
      })

    },
    getCkxxAndJbr(dataMes){
      if(this.cur_click_type == '2'){ //变更
        APIcangku(dataMes.ckId).then((res) => {
          this.cangkuxiala = res.data.data
          this.tkdata.ckId = dataMes.ckId
          this.tkdata.ckmc = dataMes.ckmc
        })
      }else{
        APIcangku().then((res) => {
          this.cangkuxiala = res.data.data
          if(dataMes && dataMes.ckId){
            this.cangkuxiala.findIndex((item) => {
              if(item.value == dataMes.ckId){
                this.tkdata.ckId = dataMes.ckId
                this.tkdata.ckmc = dataMes.ckmc
                this.tkdata.bgyId = dataMes.bgyId
                this.tkdata.bgydh = dataMes.bgydh
                this.tkdata.bgyxm = dataMes.bgyxm
                return
              }
            })
          }
        })
        // 获取下拉经办人
        APIjingbanren().then((res) => {
          this.jingbanrenlist = res.data.data
          if(dataMes && dataMes.jbrId){
            this.jingbanrenlist.findIndex((item) => {
              if(item.value == dataMes.jbrId){
                this.tkdata.jbrId = dataMes.jbrId
                this.tkdata.jbrName = dataMes.jbrName
                return
              }
            })
          }
        })

      }
    },
    // 获取列表数据
    hzylist() {
      APIzylist(this.from).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
        this.tableData.forEach((item) => {
          item.rksl = item.rksl + item.rkslDwLabel
        })
      })
    },

    // 获取弹框中化学品级联
    hhxpjilian() {
      APIhuaxuepinJL().then((res) => {
        this.jilianlb = res.data.data
      })
    },

    // 单条数据详情
    hdantiaoxiangqing(id) {
      APIzyxiangqing(id).then((res) => {
        let mesxx = {...res.data.data}
        if(this.cur_click_type != '1' ){ //非 查看
          mesxx.ckId = this.tkdata.ckId
          mesxx.ckmc = this.tkdata.ckmc
          if(this.cur_click_type != '2'){ //非变更
            mesxx.bgyId = this.tkdata.bgyId
            mesxx.bgyxm = this.tkdata.bgyxm
            mesxx.bgydh = this.tkdata.bgydh
            mesxx.jbrId = this.tkdata.jbrId
            mesxx.jbrName = this.tkdata.jbrName
          }
        }
        this.tkdata = mesxx
        // 查看和变更
        if (this.cur_click_type == '1' || this.cur_click_type == '2') {
          this.$refs.splcRef.dataobj = res.data.data.sphjDtoList
        }
        if(this.cur_click_type != '1'){ //非查看
          this.getCkxxAndJbr(res.data.data)
        }
        if(this.tkdata.hxpBm){
            gethqdw(this.tkdata.hxpBm).then((res) => {
                this.ckslList = res.data.data
            })
        }
        this.tkdata.ckZyrkFjDto.forEach((item) => {
          this.fileList.push({
            id: item.id,
            uid: item.id,
            url: this.returnShowPic + item.wjdz
          })
        })
        this.$nextTick(() => {
          this.$refs.formTK.clearValidate() //清楚页面所有校验结果
        })
      })
    },

    // 清空弹框所有
    hqingkongsuoyou() {
      this.dialogImageUrl = ''
      this.fileList = []
      this.tkdata.id = ''
      this.tkdata.dwId = ''
      this.tkdata.rkbh = ''
      this.tkdata.ckId = ''
      this.tkdata.ckmc = ''
      this.tkdata.hxpBm = ''
      this.tkdata.rksl = ''
      this.tkdata.rkslDw = ''
      this.tkdata.rkrq = ''
      this.tkdata.zyyy = ''
      this.tkdata.bz = ''
      this.tkdata.zt = ''
      this.tkdata.bgyId = ''
      this.tkdata.bgyxm = ''
      this.tkdata.bgydh = ''
      this.tkdata.jbrId = ''
      this.tkdata.jbrName = ''
      this.tkdata.djrLabel = ''
      this.tkdata.djsj = ''
      this.tkdata.addFjDto = []
      this.tkdata.delFjDto = []
      setTimeout(() => {
        this.$refs.formTK.resetFields()
      }, 3)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-date-editor .el-range-separator {
  padding: 0 16px !important;
}
.t_out_box {
  width: 95%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1518px;
  .headerSearch {
    max-width: 1518px;

    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    margin-left: auto;
    margin-right: auto;

    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.t_con_w {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}
.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;
}
.sousuoButton {
  margin-left: 20px;
  color: #fff;
  background: #4170ff;
  border-color: #4170ff;
}
.el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

.el-cascader {
  width: 100%;
}
</style>
